import { createRoot } from "react-dom/client";
import { supabase } from "@/integrations/supabase/client";
import App from "./App.tsx";
import "./index.css";

// Detect native platform without importing @capacitor/core at entry point
// (avoids module resolution failures during Vite pre-bundling in web preview).
const isNative =
  typeof (window as any).Capacitor !== "undefined" &&
  (window as any).Capacitor.isNativePlatform?.() === true;

// On native (Capacitor), sessionStorage is unreliable — the WebView clears it
// when the app backgrounds or reloads. Use localStorage there so auth persists.
// On web, keep sessionStorage so sessions expire when the tab closes (prevents
// stale sessions leaking across tabs during role-testing).
if (!isNative) {
  (supabase as any).auth.storage = sessionStorage;

  // Migrate any leftover localStorage session into sessionStorage for this tab,
  // then clear it so future tabs start fresh.
  const LS_KEY =
    "sb-" + import.meta.env.VITE_SUPABASE_PROJECT_ID + "-auth-token";
  const existing = localStorage.getItem(LS_KEY);
  if (existing && !sessionStorage.getItem(LS_KEY)) {
    sessionStorage.setItem(LS_KEY, existing);
  }
  localStorage.removeItem(LS_KEY);
}
// Native platforms: leave auth.storage at its default (localStorage) which
// persists across WebView reloads and app backgrounding.

createRoot(document.getElementById("root")!).render(<App />);
